"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var CategoryLink = function CategoryLink(_ref) {
  var url = _ref.url,
      isCurrent = _ref.isCurrent,
      key = _ref.key,
      children = _ref.children;
  return (0, _preact.h)("a", {
    className: "knowledge-base-navigation-link ".concat(isCurrent ? 'knowledge-base-navigation-link--current' : ''),
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    key: key
  }, children);
};

var _default = CategoryLink;
exports.default = _default;